import { OrderList } from "@/components/cms/e-shop/OrderList";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Input } from "@/components/ui/input";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

export const CustomerOrders = () => {
  const { t } = useTranslation();
  const { customerEmail } = useParams();

  const [search, setSearch] = useState<string | undefined>();

  return (
    <>
      <Breadcrumb>
        <BreadcrumbList className="list-none">
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/e-shop?view=customers">{t("eShop")}</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>{customerEmail}</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <div className="flex flex-row justify-between w-full">
        <div className="font-semibold text-lg text-left flex-1">
          {customerEmail}
        </div>
        <div className="flex-1">
          <Input
            placeholder={t("search")}
            onChange={(s) => setSearch(s.target.value)}
          />
        </div>
      </div>
      <OrderList customerEmail={customerEmail} search={search} />
    </>
  );
};
